import { lazy, Suspense, ReactNode } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import BackToTop from "@/components/BackToTop";
import QuickLinksSection from "@/components/QuickLinksSection";

const Footer = lazy(() => import("@/components/Footer"));

interface RouteLayoutProps {
  children: ReactNode;
  /** Padding-top to clear the fixed navbar; pages with their own hero set this to 0. */
  topPadding?: boolean;
}

const RouteLayout = ({ children, topPadding = true }: RouteLayoutProps) => {
  const { pathname } = useLocation();
  const path = pathname.toLowerCase().replace(/\/+$/, "") || "/";
  const isMap = path === "/map";
  const isAdmin = path === "/admin" || path.startsWith("/admin/");

  return (
    <>
      <Navbar />
      <main className={topPadding ? "pt-20" : ""}>
        {!isMap && !isAdmin && <QuickLinksSection sticky />}
        {children}
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
      <BackToTop />
    </>
  );
};

export default RouteLayout;
